import * as React from "react";
import { Switch, Route } from "react-router-dom";
import { PrivateRoute, PrivateRouteAllStudies } from "../../Core/PrivateRoute";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { StudiesList } from "./StudiesList";
import { PopulationGroupsList } from "../PopulationGroups/PopulationGroupsList";
import { CreatePopulationGroupScreen } from "../PopulationGroups/CreatePopulationGroupScreen";
import { CreateStudyScreen } from "./CreateStudyScreen";
import { EditStudyScreen } from "./EditStudyScreen";
import { CoughSettings } from "./Settings/CoughSettings";
import { EditPopulationGroupScreen } from "../PopulationGroups/EditPopulationGroupScreen";
import { StudyCustomisationScreen } from "./StudyCustomisationScreen";
import { SettingEditor } from "../../Settings/setting-editor-component";

export const StudiesScreen = () => {
    return (
        <Switch>
            <PrivateRouteAllStudies exact path="/studies" permissions={[PermissionEnum.ViewStudies, PermissionEnum.CreateStudy, PermissionEnum.EditStudy]}>
                <StudiesList />
            </PrivateRouteAllStudies>
            <PrivateRouteAllStudies exact path="/studies/create" permissions={[PermissionEnum.CreateStudy]}>
                <CreateStudyScreen />
            </PrivateRouteAllStudies>
            <PrivateRouteAllStudies path="/studies/edit/:id" permissions={[PermissionEnum.EditStudy]}>
                <EditStudyScreen />
            </PrivateRouteAllStudies>
            <PrivateRouteAllStudies path="/studies/populationgroups/create" permissions={[PermissionEnum.CreatePopulationGroups]}>
                <CreatePopulationGroupScreen />
            </PrivateRouteAllStudies>
            <PrivateRouteAllStudies path="/studies/populationgroups/edit/:id" permissions={[PermissionEnum.EditPopulationGroups]}>
                <EditPopulationGroupScreen />
            </PrivateRouteAllStudies>
            <PrivateRouteAllStudies path="/studies/populationgroups/:id" permissions={[PermissionEnum.ViewPopulationGroups]}>
                <PopulationGroupsList />
            </PrivateRouteAllStudies>
            <PrivateRouteAllStudies path="/studies/settings/:id" permissions={[PermissionEnum.EditStudy]}>
                <SettingEditor settingPath="" />
            </PrivateRouteAllStudies>
            <PrivateRouteAllStudies path="/studies/CoughSettings/:id" permissions={[PermissionEnum.EditStudy]}>
                <CoughSettings />
            </PrivateRouteAllStudies>
            <PrivateRouteAllStudies path="/studies/customisation/:id" permissions={[PermissionEnum.CustomiseStudy]}>
                <StudyCustomisationScreen />
            </PrivateRouteAllStudies>
        </Switch>
    );
}
